<template>
  <div class="parkConfig">
    <div class="rule-form">
      <el-form ref="pointsRuleForm" :model="pointsRuleForm" hide-required-asterisk label-width="100px" :rules="rules">
        <el-form-item label="商场名称" prop="mallId">
          <span class="input-remark">{{ mallName }}</span>
        </el-form-item>
         <el-form-item label="结算店铺" prop="storeId">
          <el-select v-if="isEdit" v-model="pointsRuleForm.storeId" placeholder="请选择结算店铺">
            <el-option v-for="(item, index) in storeList" :label="item.name" :value="item.id" :key="index"></el-option>
          </el-select>
          <span v-if="isLook" class="input-remark">{{ pointsRuleForm.storeName?pointsRuleForm.storeName:'-' }}</span>
        </el-form-item>
         <el-form-item label="车场名称" prop="name" >
            <el-input v-if="isEdit" placeholder="请输入车场名称" v-model="pointsRuleForm.name" class="input" >
            </el-input>
          <span v-if="isLook" class="input-remark mr10">{{pointsRuleForm.name?pointsRuleForm.name:'-'}}</span>
         </el-form-item>
          <el-form-item label="车场供应商" prop="supplier">
            <el-select v-if="isEdit" v-model="pointsRuleForm.supplier" placeholder="请选择车场供应商" @change="chne">
            <el-option v-for="(item, index) in supplierList" :label="item.name" :value="item.supplier" :key="index"></el-option>
          </el-select>
            <span class="input-remark mr10" v-if="isLook">{{pointsRuleForm.supplierName?pointsRuleForm.supplierName:'-'}}</span>
         </el-form-item>
          <el-form-item label="车场编号" prop="parkId">
            <el-input v-if="isEdit"  placeholder="请输入车场编号" v-model="pointsRuleForm.parkId" class="input" >
            </el-input>
            <span v-if="isLook" class="input-remark mr10">{{pointsRuleForm.parkId?pointsRuleForm.parkId:'-'}}</span>
         </el-form-item>
            <!-- 动态字段 -->
          <div v-for="(item,index) in pointsRuleForm.baseParamList" :key="index">
            <el-form-item :label="item.uiName" :prop="'baseParamList.' + index + '.value'" :rules="[{ required: true, message: '请输入'}]" v-if="item.nullable?false:true" >
            <el-input v-if="isEdit" v-model="item.value" class="input">
            </el-input>
            <span v-if="isLook" class="input-remark mr10">{{item.value?item.value:'-'}}</span>
         </el-form-item>
          </div>
          <!-- 动态字段-->
          <el-form-item label="图片" prop="picture">
          <UploadImg v-if="isEdit" @getUploadFile="getUploadFile" :uploadUrl="pointsRuleForm.picture" :desc="'建议：上传345*145的jpg,png的图片'"></UploadImg>
          <img @click="lookBigImg(pointsRuleForm.picture)" v-if="isLook&&pointsRuleForm.picture" :src="pointsRuleForm.picture" class="picUrl">
           <div v-else>-</div>
          </el-form-item>
          <el-form-item label="车场描述" prop="description">
          <el-input v-if="isEdit" type="textarea" rows="6" v-model="pointsRuleForm.description" placeholder="请输入车场描述" maxlength="2000" show-word-limit />
          <div v-if="isLook&&pointsRuleForm.description" class="lookTextArea">
            {{ pointsRuleForm.description}}
          </div>
          <div v-else>-</div>
        </el-form-item> 
      </el-form>
    </div>
    <div class="footer">
      <el-button @click="onBack" class="fun-btn mr20">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="onSavePointsRule" class="fun-btn" v-if="!isLook">确定</el-button>
      <auth-button auth="parking:lot:update">
        <el-button type="primary" class="fun-btn" @click="onEdit" v-if="isLook">编辑</el-button>
      </auth-button>
    </div>
  </div>
</template>

<script>
import UploadImg from '@/components/UploadImg/index'
import AuthButton from '@/components/AuthButton'
import { api_getParkingStoreList, api_getParkingLotSupplierList,api_getParkingLot,api_postParkingLot,api_putParkingLot } from '@/api/parking'
import { api_postFileUpload, api_getConfig } from '@/api/common'
export default {
  name: "parkConfig",
  components: {
    AuthButton,
    UploadImg
  },
  data() {
    return {
      isLook: false,
      isEdit: false,
      mallOption: [],
      isEncValue:'',
      pointsRuleForm: {
        parkId:'',
        name:'',
        picture: '',
        description: '',
        supplier:'',
        supplierName:'',
        baseParamList:'',
        mallId: ''
      },
      rules: {
        storeId: [{ required: true, message: '请选择结算店铺' }],
        name: [{ required: true, message: '输入车场名称' }],
        supplier: [{ required: true, message: '请选择车场供应商' }],
        parkId: [{ required: true, message: '请输入车场编号' }],
      },
      storeList:[],
      supplierList:[],
      mallName:'',
      submitLoading: false
    };
  },
  created() {
    this.getConfigData()
    if (this.$route.query.id) {
      this.getDefaultRule()
    }
    if (this.$route.query.type != 'look'){
      this.isLook = false
      this.isEdit = true
    } else {
      this.isLook = true
      this.isEdit = false
    }
    this.pointsRuleForm.mallId = this.$route.query.mallId
    this.getParkingStoreList(this.$route.query.mallId)
    this.getParkingLotSupplierList(this.$route.query.mallId)
  },
  methods: {
    // 获取config数据（商场、店铺级联框）
    async getConfigData() {
      let {mall} = await api_getConfig(['mall'])
      this.mallOption = mall
      this.mallOption.forEach(element => {
        if(this.$route.query.mallId == element.id){
          this.mallName = element.name
        }
      });
    },
    chne(item){
      this.supplierList.forEach(element => {
        if(item==element.supplier){
          this.pointsRuleForm.baseParamList = element.baseParamList
        }
      });
      this.$forceUpdate()
    },
    //获取车场供应商List
    async getParkingLotSupplierList(mallId) {
      let res = await api_getParkingLotSupplierList({mallId})
      res = JSON.parse(JSON.stringify(res)) 
      res.map(item=>{
        if(item.baseParamList&&item.baseParamList.length!=0){
            let arr = []
            arr =  item.baseParamList.map(element=>{
              return {
                ...element,
                value:''
              }
            })
             item.baseParamList = arr
        }
      })
      this.supplierList = res
    },
    //获取支付店铺List
    async getParkingStoreList(mallId) {
      const res = await api_getParkingStoreList({mallId})
      this.storeList = res
    },
    onEdit () {
      this.isLook = false
      this.isEdit = true
    },
    getUploadFile (file) {
      this.pointsRuleForm.picture = file
    },
    //查看详情
    async getDefaultRule () {
      const data = await api_getParkingLot({id: this.$route.query.id})
      this.pointsRuleForm = {
        ...data,
        picture:data.picture?data.picture:''
      }
      if (this.pointsRuleForm&&this.pointsRuleForm.baseParamList&&this.pointsRuleForm.baseParamList.length!=0) {
        this.pointsRuleForm.baseParamList.map((item)=>{
          if (item.enc) {
            item.isEncValue = item.value
          }
        })
      }
      this.supplierList.forEach(element => {
        if(this.pointsRuleForm.supplierName==element.name){
          this.pointsRuleForm.supplier = element.supplier
        }
      });
      this.storeList.forEach(element => {
        if(this.pointsRuleForm.storeId==element.id){
          this.pointsRuleForm.storeName = element.name
        }
      });
    },
    // 提交保存
    onSavePointsRule() {
      this.$refs.pointsRuleForm.validate(async (valid) => {
        if (valid) {
          this.submitLoading = true
          let params = {...this.pointsRuleForm}
            
          if (this.pointsRuleForm.picture&&this.pointsRuleForm.picture.size) {
            const { key } = await api_postFileUpload(this.pointsRuleForm.picture, 'Parking')
            params.picUrl = key
          }
          if (this.$route.query.id) {
            params.id = Number(this.$route.query.id)
          }
          console.log(this.$route.query.id)
          if (this.$route.query.id&&params&&params.baseParamList&&params.baseParamList.length!=0) {
           params.baseParamList = params.baseParamList.map((item)=>{
              if (item.enc&&item.value!=item.isEncValue) {
                  item.update = true
              }
              return item
            })
          }
          delete params.supplierName
          delete params.picture
          try {
            this.$route.query.id?await api_putParkingLot(params):await api_postParkingLot(params)
            this.$baseMessage('保存成功', 'success')
            this.$router.back(-1)
            this.submitLoading = false
          } catch (error) {
            this.submitLoading = false
          }
        } else {
          return false
        }
      })
    },
    // 查看大图
    lookBigImg (src) {
      const image = new Image()
      image.src = src
      image.onload = () => {
        image.style.margin = "0 auto"
        image.style.display = "block"
        const newWin = window.open("", "_blank")
        newWin.document.write(image.outerHTML)
      }
    },
    // 返回
    onBack() {
      if(this.$route.query.id&&this.isEdit){
      this.isLook = true
      this.isEdit = false
      }else{
        this.$router.back(-1)
      }
      
    },
  },
};
</script>

<style lang="scss" scoped>
.parkConfig {
  width: 100%;
  padding: 35px 20px;
  padding-top: 0;
  padding-bottom: 74px;
  box-sizing: border-box;
  .divider1 {
    margin: 0;
    margin-top: 28px;
  }
  .divider2 {
    margin: 0;
  }
  .el-input,
  .el-textarea,
  .el-select {
    width: 250px;
  }
  .title {
    height: 25px;
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    line-height: 25px;

    .btn.el-button {
      color: #1A5CF5;
      margin-left: 10px;
    }
  }

  .rule-form {
    margin-top: 20px;
    .el-textarea{
      width: 350px;
    }
    .el-input {
      width: 250px;
    }

    .input-remark {
      font-size: 14px;
      color: #333333;
      margin-left: 10px;
    }

    .hint-remark {
      font-size: 12px;
      display: inline-block;
      position: relative;
      width: 400px;
      height: 34px;
      color: #666666;
      .text {
        height: 17px;
        line-height: 17px;
        position: absolute;
        left: 0;
        bottom: 8px;
      }
    }

    .deduction-rule-box {
      display: flex;
    }
  }

  .shop-rule-box {
    margin-top: 20px;

    .fun-btn-box {
      margin: 20px 0;
    }
  }

  .add-rule-dialog {
    padding-top: 20px;
    position: relative;
    .dialog-footer {
      text-align: right;
    }
    ::v-deep{
      .el-select{
        width: 100%;
      }
      .el-form-item{
        &.notes {
          margin-bottom: 32px;
          .el-form-item__content {
            &::before {
              position: absolute;
              left: 0;
              bottom: -22px;
              content: '( 填写“0”表示永久有效 )';
              width: 140px;
              height: 17px;
              line-height: 17px;
              font-size: 12px;
              color: #666666;
            }
            .el-form-item__error {
              height: 17px;
              left: 140px;
              padding-top: 7px;
            }
          }
        }
      }
    }
  }
  .status{
    width: 6px;
    height: 6px;
    display: inline-block;
    border-radius: 50%;
    vertical-align: middle;
  }
  .true{
    background: #F74A4A;
  }
  .false{
    background: #05c8af;
  }
  .picUrl{
    width: 150px;
    height: 150px;
    display: inline-block;
    object-fit: fill;
    object-fit: contain;
    object-fit: cover;
    object-fit: none;
    object-fit: scale-down;
  }
  .lookTextArea{
    width: 400px;
    height: 200px;
    background: #F2F3F5;
    border-radius: 2px;
    overflow: auto;
    padding: 20px;
    box-sizing: border-box;
    font-size: 14px;
    color: #999999;
    line-height: 20px;
  }
  .footer{
    position: fixed;
    bottom: 0;
    padding: 20px 0;
    padding-left: 70px;
    background: #fff;
    width: calc(100vw - #{$base-left-menu-width});
    left: $base-left-menu-width;
  }
}
</style>
